(() => {
  const element = document.getElementById('fermata-english-data');
  if (!element || !/^(en|ko|zh)(-|$)/i.test(document.documentElement.lang)) return;
  const entities = { '&amp;': '&', '&quot;': '"', '&#39;': "'", '&#x27;': "'", '&apos;': "'", '&lt;': '<', '&gt;': '>' };
  const data = JSON.parse(element.textContent, (_key, value) => typeof value === 'string' ? value.replace(/&(?:amp|quot|#39|#x27|apos|lt|gt);/g, entity => entities[entity]) : value);
  const clean = value => String(value || '').replace(/\s+/g, ' ').trim();
  const words = new Map((data.quiz || []).map(([source, translated]) => [clean(source), translated]));
  if (document.documentElement.lang === 'ko') { words.set('Read more', '더 보기'); words.set('Read less', '접기'); }
  if (/^zh/i.test(document.documentElement.lang)) { words.set('Read more', '顯示更多'); words.set('Read less', '收起'); }
  const catalog = new Map((data.catalog || []).map(item => [clean(item.title), item.handle]));
  const imageProfiles = new Map((/^zh/i.test(document.documentElement.lang) ? [] : data.images || []).map(item => [item.file, item]));
  if (document.documentElement.lang === 'ko') imageProfiles.set("device-01_c4772793-2b37-411d-8698-26069748f53b.jpg", {"file":"device-01_c4772793-2b37-411d-8698-26069748f53b.jpg","alt":"HOMTECH 딥 클렌징 디바이스. 냄새의 원인이 되는 피지와 땀을 씻어내는 케어. D클리닉 감수.","labels":[{"text":"새로운 냄새 세정 케어","x":0.045,"y":0.04,"w":0.57,"h":0.27,"footer":true},{"text":"민감한 부위를 위한 케어. 냄새의 원인이 되는 피지와 땀을 씻어냅니다.","x":0.045,"y":0.3,"w":0.57,"h":0.13,"footer":true},{"text":"D클리닉 감수","x":0.045,"y":0.443,"w":0.26,"h":0.18,"footer":true}]});
  const localizedRoot = data.root.replace(/\/$/, '') + '/';
  const productCache = new Map();
  const imageRecords = new Map();
  let recommendations = [];
  let quizRoot;
  let quizObserver;
  let quizQueued = false;
  let imageQueued = false;

  const setText = (element, text) => {
    if (!element || element.textContent === text) return;
    if (document.documentElement.lang === 'ko' && /[\u3040-\u30ff\u3400-\u9fff]/.test(text)) return;
    if (element.childNodes.length === 1 && element.firstChild.nodeType === Node.TEXT_NODE) element.firstChild.nodeValue = text;
    else element.textContent = text;
  };

  const scheduleQuiz = () => {
    if (quizQueued) return;
    quizQueued = true;
    requestAnimationFrame(() => { quizQueued = false; localizeQuiz(); });
  };

  const getProduct = handle => {
    if (!productCache.has(handle)) {
      const entry = { product: null, failed: false };
      productCache.set(handle, entry);
      fetch(localizedRoot + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(response => { if (!response.ok) throw new Error('Product unavailable'); return response.json(); })
        .then(product => { entry.product = product; scheduleQuiz(); })
        .catch(() => { entry.failed = true; });
    }
    return productCache.get(handle).product;
  };

  const localizeQuiz = () => {
    if (!quizRoot?.isConnected) return;
    quizObserver.disconnect();
    const walker = document.createTreeWalker(quizRoot, NodeFilter.SHOW_TEXT, { acceptNode: node => node.parentElement?.closest('script,style') ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT });
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(node => {
      const translated = words.get(clean(node.nodeValue));
      if (translated && translated !== node.nodeValue) { node.nodeValue = translated; if (/^(ko|zh)/i.test(document.documentElement.lang)) node.parentElement.setAttribute('translate', 'no'); }
    });
    quizRoot.querySelectorAll('[aria-label],[title]').forEach(node => {
      ['aria-label', 'title'].forEach(attribute => {
        const translated = words.get(clean(node.getAttribute(attribute)));
        if (translated) node.setAttribute(attribute, translated);
      });
    });
    quizRoot.querySelector('[data-testid="previous-button"]')?.setAttribute('aria-label', data.previous);
    quizRoot.querySelector('[data-testid="next-button"]')?.setAttribute('aria-label', data.next);
    const collectionDescription = quizRoot.querySelector('[class*="DescriptionCollection-"]');
    const collectionHeading = quizRoot.querySelector('h1');
    const collection = (data.collections || []).find(item => [item.source, item.title].some(title => clean(title) === clean(collectionHeading?.textContent)));
    if (collection) {
      setText(collectionHeading, collection.title);
      setText(collectionDescription, collection.description);
      const collectionImage = quizRoot.querySelector('[data-testid="collection-image"]');
      if (collectionImage) collectionImage.alt = collection.title;
      quizRoot.querySelectorAll('[class*="StyledCollectionCard-"]').forEach(card => {
        if (/^(ko|zh)/i.test(document.documentElement.lang)) card.setAttribute('translate', 'yes');
        if (/^zh/i.test(document.documentElement.lang)) {
          const label = card.querySelector('[class*="StyledProductInfoText-"]');
          setText(label, data.viewCollection);
          label?.setAttribute('translate', 'no');
        }
        card.dataset.fmQuizUrl = localizedRoot + 'collections/' + encodeURIComponent(collection.handle);
        card.setAttribute('role', 'link');
        card.setAttribute('tabindex', '0');
        card.setAttribute('aria-label', data.viewCollection + ': ' + collection.title);
      });
    }
    const cards = Array.from(quizRoot.querySelectorAll('[class*="StyledProductCard-"]')).filter(card => !card.className.includes('StyledCollectionCard-'));
    cards.forEach((card, index) => {
      if (/^(ko|zh)/i.test(document.documentElement.lang)) card.setAttribute('translate', 'yes');
      const image = card.querySelector('img');
      const title = card.querySelector('[title]');
      if (!image || !title) return;
      const observedTitle = clean(image.alt);
      const handle = catalog.get(observedTitle) || (card.dataset.fmSourceTitle === observedTitle ? card.dataset.fmHandle : '') || recommendations[index]?.handle;
      if (!handle) return;
      const recommendation = recommendations.find(item => item.handle === handle);
      card.dataset.fmHandle = handle;
      const product = getProduct(handle);
      if (!product) return;
      if (/^zh/i.test(document.documentElement.lang) && handle === 'fullmoon_clean_cup' && Number(product.price) === 0) {
        card.hidden = true;
        card.style.display = 'none';
        return;
      }
      const variant = product.variants?.find(item => String(item.id) === String(recommendation?.variantId));
      const showVariant = clean(title.getAttribute('title')).includes(' - ') || title.dataset.fmShowVariant === 'true';
      if (showVariant) title.dataset.fmShowVariant = 'true';
      const variantText = variant?.title && variant.title !== 'Default Title' ? variant.title : '';
      const variantLabel = /^zh/i.test(document.documentElement.lang)
        ? variantText.replace(/<[^>]*>/g, '').trim().split(/\s*\/\s*/).map(value => ({"ナチュラル":"原棉色","自然":"原棉色","ブラック":"黑色","サンド":"沙色","沙子":"沙色","レンガ":"磚紅色","磚":"磚紅色","ジンジャースパイス":"Ginger Spice","薑香料":"Ginger Spice","オレンジ":"橘色","橘子":"橘色","タン(ベージュ)":"淺褐色（米色）","パープル":"紫色","ブルー（ラメ）":"藍色（亮粉）","ブルー":"藍色","クリア":"透明","ミント":"薄荷綠"})[value] || value.replace(/※\s*([XSML0-9-]+)(?:相当|\s*大致)/g, '（約相當於 $1）')).join(' / ')
        : variantText;
      let label = product.title + (showVariant && variantLabel ? ' — ' + variantLabel : '');
      if (/^zh/i.test(document.documentElement.lang)) {
        label = label.replace(/<br\s*\/?\s*>/gi, '・').replace(/<[^>]+>/g, '').replace(/([SML])サイズ/g, '$1號').trim();
        if (!/[\u3041-\u3096\u30a1-\u30fa]/.test(label)) title.setAttribute('translate', 'no');
      }
      setText(title, label);
      title.setAttribute('title', label);
      image.alt = product.title;
      card.dataset.fmSourceTitle = product.title;
      card.dataset.fmQuizUrl = localizedRoot + 'products/' + encodeURIComponent(handle) + (recommendation?.variantId ? '?variant=' + encodeURIComponent(recommendation.variantId) : '');
      card.setAttribute('role', 'link');
      card.setAttribute('tabindex', '0');
      card.setAttribute('aria-label', label);
      const info = card.querySelector('[class*="StyledProductInfo-"]');
      const price = info?.lastElementChild;
      if (price && price !== title) {
        const original = clean(price.textContent);
        if (/^[\d,.]+\s*円$/.test(original)) setText(price, 'JPY ' + original.replace(/\s*円$/, ''));
      }
    });
    quizObserver.observe(quizRoot, { childList: true, subtree: true, characterData: true });
  };

  const connectQuiz = () => {
    const root = document.getElementById('gojiberryProductQuizRoot');
    if (!root || root === quizRoot) return;
    quizObserver?.disconnect();
    quizRoot = root;
    if (/^(ko|zh)/i.test(document.documentElement.lang)) root.setAttribute('translate', 'no');
    quizObserver = new MutationObserver(scheduleQuiz);
    const openLink = event => {
      const card = event.target.closest('[data-fm-quiz-url]');
      if (!card || !quizRoot.contains(card)) return;
      if (event.type === 'keydown') {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        card.click();
        return;
      }
      const originalOpen = window.open;
      const destination = new URL(card.dataset.fmQuizUrl, location.href);
      const unlocalizedPath = destination.pathname.replace(localizedRoot, '/');
      const localizedOpen = function (url, ...options) {
        if (window.open === localizedOpen) window.open = originalOpen;
        let target = url;
        try {
          const requested = new URL(String(url), location.href);
          if (requested.origin === location.origin && requested.pathname === unlocalizedPath) target = destination.href;
        } catch {}
        return originalOpen.call(window, target, ...options);
      };
      window.open = localizedOpen;
      setTimeout(() => { if (window.open === localizedOpen) window.open = originalOpen; }, 0);
    };
    root.addEventListener('click', openLink, true);
    root.addEventListener('keydown', openLink, true);
    localizeQuiz();
  };

  document.addEventListener('gojiberry-onProductsRecommended', event => {
    recommendations = Array.isArray(event.detail?.products) ? event.detail.products : [];
    scheduleQuiz();
  });

  const scheduleImages = () => {
    if (imageQueued) return;
    imageQueued = true;
    requestAnimationFrame(() => { imageQueued = false; localizeImages(); });
  };

  const resize = new ResizeObserver(scheduleImages);
  const localizeImages = () => {
    connectQuiz();
    for (const [image, record] of imageRecords) {
      if (!image.isConnected) {
        record.layer.remove();
        resize.unobserve(image);
        imageRecords.delete(image);
      }
    }
    document.querySelectorAll('img').forEach(image => {
      let filename;
      try { filename = decodeURIComponent(new URL(image.currentSrc || image.src, location.href).pathname.split('/').pop()); } catch { return; }
      const profile = imageProfiles.get(filename);
      const old = imageRecords.get(image);
      if (!profile) {
        if (old) { old.layer.remove(); resize.unobserve(image); imageRecords.delete(image); }
        return;
      }
      let record = old;
      if (record && record.file !== profile.file) { record.layer.remove(); imageRecords.delete(image); record = null; }
      if (!record) {
        const parent = image.parentElement.tagName === 'PICTURE' ? image.parentElement.parentElement : image.parentElement;
        if (!parent || parent.namespaceURI !== 'http://www.w3.org/1999/xhtml') return;
        if (getComputedStyle(parent).position === 'static') parent.style.position = 'relative';
        const layer = document.createElement('span');
        layer.className = 'fm-english-image';
        layer.setAttribute('aria-hidden', 'true');
        profile.labels.forEach(label => {
          const text = document.createElement('span');
          text.className = 'fm-english-image__text ' + (label.footer ? 'fm-english-image__text--footer' : '');
          text.textContent = label.text;
          text.style.left = label.x * 100 + '%';
          text.style.top = label.y * 100 + '%';
          text.style.width = label.w * 100 + '%';
          text.style.height = label.h * 100 + '%';
          layer.appendChild(text);
        });
        parent.appendChild(layer);
        record = { layer, parent, file: profile.file };
        imageRecords.set(image, record);
        resize.observe(image);
        image.addEventListener('load', scheduleImages);
      }
      const rect = image.getBoundingClientRect();
      const parentRect = record.parent.getBoundingClientRect();
      let width = rect.width;
      let height = rect.height;
      let x = rect.left - parentRect.left - record.parent.clientLeft + record.parent.scrollLeft;
      let y = rect.top - parentRect.top - record.parent.clientTop + record.parent.scrollTop;
      const fit = getComputedStyle(image).objectFit;
      if (fit === 'contain' && image.naturalWidth && image.naturalHeight) {
        const scale = Math.min(width / image.naturalWidth, height / image.naturalHeight);
        const actualWidth = image.naturalWidth * scale;
        const actualHeight = image.naturalHeight * scale;
        x += (width - actualWidth) / 2;
        y += (height - actualHeight) / 2;
        width = actualWidth;
        height = actualHeight;
      }
      Object.assign(record.layer.style, { left: x + 'px', top: y + 'px', width: width + 'px', height: height + 'px', display: width > 0 && height > 0 ? 'block' : 'none' });
      record.layer.style.setProperty('--fm-image-font', Math.max(5, Math.min(22, width * 0.045)) + 'px');
      image.alt = profile.alt;
    });
  };

  new MutationObserver(scheduleImages).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'srcset'] });
  window.addEventListener('resize', scheduleImages, { passive: true });
  connectQuiz();
  localizeImages();
})();

(() => {
  if (!document.documentElement.lang.toLowerCase().startsWith('en')) return;
  const element = document.getElementById('fermata-recheck-data');
  if (!element) return;
  const entities = { '&amp;': '&', '&quot;': '"', '&#39;': "'", '&#x27;': "'", '&apos;': "'", '&lt;': '<', '&gt;': '>' };
  const data = JSON.parse(element.textContent, (_key, value) => typeof value === 'string' ? value.replace(/&(?:amp|quot|#39|#x27|apos|lt|gt);/g, entity => entities[entity]) : value);
  const clean = text => String(text || '').replace(/\s+/g, ' ').trim();
  const words = new Map(data.common.map(([source, translated]) => [clean(source), translated]));
  const reviews = new Map(data.reviews.map(([source, translated]) => [clean(source), translated]));
  const japanese = /[ぁ-んァ-ヶ一-龠]/;
  const originalReviews = new WeakMap();
  const reviewSelector = '.jdgm-rev__body,.jdgm-rev__title,.jdgm-rev__reply-content,.jdgm-review-content__body-content,.jm-review-content__title,.jm-shop-reply__text';
  let queued = false;
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; localize(); });
  });
  const localize = () => {
    observer.disconnect();
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: node => node.parentElement?.closest('script,style,textarea,input,[contenteditable],.jdgm-rev__author,.jm-reviewer-info__name,.jdgm-rev__body,.jdgm-rev__title,.jdgm-rev__reply-content,.jdgm-review-content__body-content,.jm-review-content__title,.jm-shop-reply__text,#gojiberryProductQuizRoot') ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT
    });
    while (walker.nextNode()) {
      const node = walker.currentNode;
      const source = clean(node.nodeValue);
      let translated = words.get(source);
      if (!translated && /^[\d,]+件のレビュー$/.test(source)) {
        const count = source.match(/^[\d,]+/)[0];
        translated = (count === '1' ? data.reviewOne : data.reviewMany).replace('[count]', count);
      }
      if (!translated && /\d[\d,.]*\s*円/.test(source)) translated = source.replace(/(\d[\d,.]*)\s*円(?:\s*JPY)?/g, '$1 JPY');
      if (translated && translated !== source) node.nodeValue = node.nodeValue.replace(source, translated);
    }
    document.querySelectorAll(reviewSelector).forEach(container => {
      if (originalReviews.has(container)) return;
      const nodes = container.querySelectorAll('p').length ? Array.from(container.querySelectorAll('p')) : [container];
      const entries = nodes.map(node => ({node, source: node.textContent, translated: reviews.get(clean(node.textContent))})).filter(entry => entry.translated);
      if (!entries.length) return;
      originalReviews.set(container, entries);
      entries.forEach(entry => { entry.node.textContent = entry.translated; });
      const note = document.createElement('span');
      note.className = 'fm-review-translation';
      const label = document.createElement('span');
      label.textContent = data.translated;
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = data.showOriginal;
      button.setAttribute('aria-expanded', 'false');
      let showOriginal = false;
      button.addEventListener('click', () => {
        showOriginal = !showOriginal;
        entries.forEach(entry => {
          if (entry.node === container) {
            const text = container.firstChild;
            if (text?.nodeType === Node.TEXT_NODE) text.nodeValue = showOriginal ? entry.source : entry.translated;
          } else entry.node.textContent = showOriginal ? entry.source : entry.translated;
        });
        label.textContent = showOriginal ? data.original : data.translated;
        button.textContent = showOriginal ? data.showTranslation : data.showOriginal;
        button.setAttribute('aria-expanded', String(showOriginal));
      });
      note.append(label, document.createTextNode(' · '), button);
      container.appendChild(note);
    });
    document.querySelectorAll('[aria-label]').forEach(node => {
      const label = node.getAttribute('aria-label');
      if (/\d[\d,.]*\s*円/.test(label)) node.setAttribute('aria-label', label.replace(/(\d[\d,.]*)\s*円(?:\s*JPY)?/g, '$1 JPY'));
    });
    document.querySelectorAll('.jm-reviewer-avatar__initial .jm-text').forEach(node => { if (clean(node.textContent) === '匿') node.textContent = 'A'; });
    document.querySelectorAll('img[alt]').forEach(image => {
      if (!japanese.test(image.alt)) return;
      const card = image.closest('.grid-product');
      const title = card?.querySelector('.grid-product__title') || (image.closest('product-images') ? image.closest('.shopify-section')?.querySelector('h1,h2') : null);
      if (title && !japanese.test(title.textContent)) image.alt = clean(title.textContent);
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  };
  localize();
})();
